<div class="container">
  <div class="row header">
    <div class="col">
      <button class="btn btn-primary" (click)="goToPreviousMonth()">Previous Month</button>
    </div>
    <div class="col text-center">
      <h4>{{ doctor.name | titlecase }}</h4>
    </div>
    <div class="col text-end">
      <button class="btn btn-primary" (click)="goToNextMonth()">Next Month</button>
    </div>
  </div>
  <hr>
    <div class="row gy-4 row-cols-1 row-cols-md-2">
      @for (date of dateList; track date) {
        <div class="col">
          <div class="d-flex flex-column flex-lg-row">
            <div class="w-25"
              style="text-align: center; background-color: rgb(242, 241, 241); border-radius: 5px; padding: 15px;">
              <span class="rounded img-fluid d-block w-100 fit-cover" style="height: 100px;">
                <b>{{ date | date: 'EEEE' }}</b>
                <br>
                  {{ date | date: 'MMM d' }}
                </span>
              </div>
              <div class="py-4 py-lg-0 px-lg-4">
                <table class="table">
                  @for (slot of getThisDaySlots(date); track slot) {
                    <tr>
                      <td>{{slot.date_time | date:'hh:mm a'}}</td>
                      <td class="px-3">-</td>
                      <td>{{slot.date_time_to | date:'hh:mm a'}}</td>
                      <td class="px-2">{{slot.reason}}</td>
                    </tr>
                  }
                </table>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="py-4"></div>
    </div>